import { Link } from "react-router-dom";
import type { Guide } from "@/types/content";

export default function GuideCard({ item }: { item: Guide }) {
  return (
    <article className="h-full">
      <Link
        to={`/guides/${item.id}`}
        className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-400"
      >
        <div className="relative aspect-[3/2] w-full overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={item.coverAlt}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 rounded-full bg-secondary-900/90 px-3 py-1 text-xs font-medium text-background-50">
            {item.category}
          </span>
        </div>
        <div className="flex flex-1 flex-col p-5">
          <h3 className="font-heading text-base font-bold leading-6 text-foreground-950 transition-colors group-hover:text-accent-700">
            {item.title}
          </h3>
          <p className="mt-3 line-clamp-2 flex-1 text-sm leading-6 text-foreground-600">
            {item.summary}
          </p>
          <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-background-200 pt-4 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-book-open-line text-accent-500" aria-hidden="true" />
              {item.steps.length} 个要点
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line" aria-hidden="true" />
              {item.readMinutes} 分钟
            </span>
            <span>{item.date}</span>
          </div>
        </div>
      </Link>
    </article>
  );
}